import React, { useState, useCallback } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { MUI_MOBILE_BREAKPOINT } from '../../../../utils/constants';
import { SalesChannel, OrderHistoryFiltersAndSearchProps } from './types';
import { InitialUrlSearchParams } from '../../../../utils/environment';
import { updateBrowserHistoryState } from './helpers';

const urlParams = InitialUrlSearchParams;

const CHANNELS: Array<{ value: SalesChannel; label: string }> = [
  { value: 'all', label: 'ALL' },
  { value: 'online', label: 'ONLINE' },
  { value: 'in_store', label: 'IN STORE' },
];

const OrderHistoryFiltersAndSearch = ({ onFiltersChange, hideSearchOnMobile }: OrderHistoryFiltersAndSearchProps) => {
  const [salesChannel, setSalesChannel] = useState<SalesChannel>((urlParams.get('channel') as SalesChannel) || 'all');
  const [searchQuery, setSearchQuery] = useState(urlParams.get('query') || '');
  const [searchInput, setSearchInput] = useState(urlParams.get('query') || '');
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true });

  const handleChannelChange = useCallback(
    (channel: SalesChannel) => {
      setSalesChannel(channel);
      updateBrowserHistoryState({ channel, page: '1' });
      onFiltersChange({ salesChannel: channel, searchQuery, page: 1 });
    },
    [searchQuery, onFiltersChange]
  );

  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
  }, []);

  const handleSearchSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const value = searchInput.trim();
      setSearchQuery(value);
      updateBrowserHistoryState({ query: value || null, page: '1' });
      onFiltersChange({ salesChannel, searchQuery: value, page: 1 });
    },
    [salesChannel, onFiltersChange, searchInput]
  );

  const handleSearchBlur = useCallback(() => {
    const value = searchInput.trim();
    if (!value && searchQuery) {
      setSearchQuery('');
      updateBrowserHistoryState({ query: null, page: '1' });
      onFiltersChange({ salesChannel, searchQuery: '', page: 1 });
    }
  }, [searchQuery, salesChannel, onFiltersChange, searchInput]);

  return (
    <div className="order-history-filters">
      <div className="channel-tabs">
        {CHANNELS.map((channel) => (
          <button
            key={channel.value}
            className={`large-sub-nav-link channel-tab ${salesChannel === channel.value ? 'active' : ''}`}
            onClick={() => handleChannelChange(channel.value)}
          >
            {channel.label}
          </button>
        ))}
      </div>
      {!(isMobile && hideSearchOnMobile) && (
        <form className="search-bar" role="search" onSubmit={handleSearchSubmit}>
          <label className="visually-hidden" htmlFor="order-history-search-input">
            Search all orders
          </label>
          <span className="alo-search-icon" aria-hidden="true"></span>
          <input
            type="search"
            id="order-history-search-input"
            name="order-history-search"
            className="search-input body-large"
            placeholder="Search all orders"
            value={searchInput}
            onChange={handleSearchChange}
            onBlur={handleSearchBlur}
          />
          <button type="submit" className="visually-hidden">
            Submit search
          </button>
        </form>
      )}
    </div>
  );
};

export default OrderHistoryFiltersAndSearch;
